import { render } from "./TeamField.vue?vue&type=template&id=30d13a42&scoped=true"
import script from "./TeamField.vue?vue&type=script&lang=js"
export * from "./TeamField.vue?vue&type=script&lang=js"

import "./TeamField.vue?vue&type=style&index=0&id=30d13a42&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d13a42"]])

export default __exports__